import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-zatca-phase-two',
  templateUrl: './zatca-phase-two.component.html',
  styleUrls: ['./zatca-phase-two.component.scss']
})
export class ZatcaPhaseTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
